import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { bindActionCreators as bindScopedActionCreators } from 'multireducer';
import { connect } from 'react-redux';
import * as contextActions from "../store/context/actions.js";
import * as activePickerActions from "../store/activePicker/actions.js";
import * as searchActions from "../store/search/actions.js";
import * as outcomePickerActions from "../store/OutcomePicker/actions.js";
import * as trayActions from "../store/OutcomeTray/actions.js";
import { getSearchText, getIsSearchLoading, getSearchEntries, getSearchPage, getSearchTotal } from "../store/search/selectors.js";
import { getFocusedOutcome, getSelectedOutcomeIds, getOutcomePickerState, makeIsOutcomeSelected } from "../store/OutcomePicker/selectors.js";
import { getOutcomeList, getListPage, getListTotal } from "../store/OutcomeTray/selectors.js";
import OutcomeTray from "../components/OutcomeTray/index.js";
import { isOpen } from "../store/activePicker/selectors.js";
import { getFeatures } from "../store/features/selectors.js";
function mapStateToProps(state, ownProps) {
  var scope = ownProps.scope;
  return {
    searchText: getSearchText(state, scope),
    isSearchLoading: getIsSearchLoading(state, scope),
    searchEntries: getSearchEntries(state, scope),
    searchPage: getSearchPage(state, scope),
    searchTotal: getSearchTotal(state, scope),
    isOpen: isOpen(state, scope),
    isFetching: getOutcomePickerState(state, scope) === 'loading',
    selectedOutcomeIds: getSelectedOutcomeIds(state, scope),
    isOutcomeSelected: makeIsOutcomeSelected(state, scope),
    outcomes: getOutcomeList(state, scope),
    listPage: getListPage(state, scope),
    listTotal: getListTotal(state, scope),
    focusedOutcome: getFocusedOutcome(state, scope),
    features: getFeatures(state)
  };
}
function mapDispatchToProps(dispatch, ownProps) {
  var screenreaderNotification = ownProps.screenreaderNotification,
    scope = ownProps.scope;
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, bindScopedActionCreators(outcomePickerActions, dispatch, scope)), bindScopedActionCreators(activePickerActions, dispatch)), bindScopedActionCreators(contextActions, dispatch, scope)), bindScopedActionCreators(searchActions, dispatch, scope)), bindScopedActionCreators(trayActions, dispatch, scope)), {}, {
    screenreaderNotification: screenreaderNotification
  });
}
export default connect(mapStateToProps, mapDispatchToProps)(OutcomeTray);